import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from "@/components/ui/alert-dialog";

export const CrossReplaceDialog = ({ open, otherLabel, currentLabel, onConfirm, onCancel }) => (
  <AlertDialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
    <AlertDialogContent className="rounded-none" data-testid="cross-replace-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Este empleado ya tiene un {otherLabel} guardado</AlertDialogTitle>
        <AlertDialogDescription>
          Si guardás este {currentLabel}, se eliminará el {otherLabel} anterior de este empleado, incluido su recibo emitido si lo tuviera. Si no guardás, no se borra nada. ¿Querés continuar?
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="rounded-none" data-testid="cross-replace-cancel-btn" onClick={onCancel}>No, cancelar</AlertDialogCancel>
        <AlertDialogAction className="rounded-none brand-bg text-white" data-testid="cross-replace-confirm-btn" onClick={onConfirm}>Sí, continuar</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
